<template>
  <div class="brands-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="brands-page__container sides-padding">
      <div class="container">
        <div class="brands-page__content">
          <BrandsComponent :brands="brands" />
          <BrandsAlphabetComponent />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import DEFAULT_PAGE from "@/graphql/pages/DefaultPage.graphql";
import BrandsComponent from "components/brands/BrandsComponent.vue";
import BrandsAlphabetComponent from "components/brands/BrandsAlphabetComponent.vue";

export default {
  name: "BrandsPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: DEFAULT_PAGE,
      })
      .then(({ data }) => {
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  computed: {
    brands() {
      return this.$store.state.popular_brands || [];
    },
    links() {
      return [{ title: "Бренды" }];
    },
  },
  components: {
    BrandsAlphabetComponent,
    BrandsComponent,
    BreadcrumbsComponent,
  },
  metaInfo: {
    title: "Бренды товаров",
  },
};
</script>

<style lang="stylus">
.brands-page {
  width 100%
  display grid
  grid-gap 50px

  &__content {
    display grid
    grid-gap 50px
  }
}
</style>
